import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  placementStep: "selectXZ",
  isPlacementMode: false,
  editingPosition: [0, 0, 0],
  editingRotation: [0, 0, 0],
  editingScale: [1, 1, 1],
  isPlaced: false,
  transformMode: "drag",
  transformAxis: "xyz",
  currentTransformState: {
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: [1, 1, 1],
  },
  selectedShape: "sphere",
  shapeParams: [0.5, 4, 1],
  placedObjects: [],
  editingObjectId: null,
};

const objectPlacementSlice = createSlice({
  name: "objectPlacement",
  initialState,
  reducers: {
    setPlacementStep: (state, action) => {
      state.placementStep = action.payload;
    },
    setIsObjectPlacementMode: (state, action) => {
      state.isPlacementMode = action.payload;
      if (action.payload === false) {
        state.placementStep = "selectXZ";
      }
    },
    setEditingPosition: (state, action) => {
      state.editingPosition = action.payload;
    },
    setTransformMode: (state, action) => {
      state.transformMode = action.payload;
      if (action.payload === "rotate") {
        state.transformAxis = "xyz";
      }
    },
    setTransformAxis: (state, action) => {
      state.transformAxis = action.payload;
    },

    updateCurrentTransformState: (state, action) => {
      state.currentTransformState = action.payload;
    },

    setSelectedShape: (state, action) => {
      state.selectedShape = action.payload;
      switch (action.payload) {
        case "cube":
          state.shapeParams = [2, 8, 4]; // width, height, depth
          break;
        case "sphere":
          state.shapeParams = [0.5]; // radius
          break;
        case "cylinder":
          state.shapeParams = [1, 4]; // radius, height
          break;
        case "cone":
        case "pyramid":
          state.shapeParams = [1, 4]; // radius, height
          break;
        case "torus":
          state.shapeParams = [4, 1]; // radius, thickness
          break;
        default:
          state.shapeParams = [2, 8, 4];
      }
    },

    updateShapeParam: (state, action) => {
      const { index, value } = action.payload;
      state.shapeParams[index] = value;
    },

    loadObject: (state, action) => {
      const { object } = action.payload;

      state.editingObjectId = object.id;
      state.selectedShape = object.shape;
      state.shapeParams = object.params;
      state.editingPosition = object.position;
      state.editingRotation = object.rotation;
      state.editingScale = object.scale;
      state.isPlaced = true;
      state.placementStep = "adjust";
      state.isPlacementMode = true;
    },

    setPlacedObjects: (state, action) => {
      state.placedObjects = action.payload;
    },
    setEditingObjectId: (state, action) => {
      state.editingObjectId = action.payload;
    },
    resetPlacement: (state) => {
      state.editingPosition = null;
      state.editingRotation = [0, 0, 0];
      state.editingScale = [1, 1, 1];
      state.isPlaced = false;
      state.transformMode = "drag";
      state.transformAxis = "xyz";
      state.placementStep = "selectXZ";
      state.editingObjectId = null;
      state.isPlacementMode = false;
    },
  },
});

export const {
  setPlacementStep,
  setIsObjectPlacementMode,
  loadObject,
  setEditingPosition,
  setTransformMode,
  setTransformAxis,
  updateCurrentTransformState,
  setSelectedShape,
  updateShapeParam,
  setPlacedObjects,
  setEditingObjectId,
  resetPlacement,
} = objectPlacementSlice.actions;

export default objectPlacementSlice.reducer;
